export const SET_USER = "AUTH_SET_USER";
export const SET_AUTH = "AUTH_SET_AUTH";
export const UNSET_AUTH = "AUTH_UNSET_AUTH";
